import { fetchAuthSession } from "aws-amplify/auth";
import {
  refreshToken,
  isTokenExpiring,
  handleTokenExpiration,
} from "./tokenManager";

export async function applyRequestAuthHeader(config, setDefaultAuthorization) {
  try {
    const session = await fetchAuthSession();

    if (!session.tokens?.accessToken) {
      return config;
    }

    let accessToken = session.tokens.accessToken;

    if (isTokenExpiring(accessToken)) {
      const refreshed = await refreshToken();
      if (!refreshed) {
        return config;
      }

      const refreshedSession = await fetchAuthSession();
      if (!refreshedSession.tokens?.accessToken) {
        return config;
      }
      accessToken = refreshedSession.tokens.accessToken;
    }

    const token = accessToken.toString();
    config.headers = config.headers ?? {};
    config.headers.Authorization = `Bearer ${token}`;
    setDefaultAuthorization(token);
  } catch (error) {
    console.warn("Could not refresh token from Amplify session:", error);
  }

  return config;
}

export function createUnauthorizedResponseHandler(
  client,
  setDefaultAuthorization
) {
  return async (error) => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      const refreshed = await refreshToken();
      if (refreshed) {
        try {
          const session = await fetchAuthSession();
          if (session.tokens?.accessToken) {
            const token = session.tokens.accessToken.toString();
            originalRequest.headers = originalRequest.headers ?? {};
            originalRequest.headers.Authorization = `Bearer ${token}`;
            setDefaultAuthorization(token);
            return client(originalRequest);
          }
        } catch (retryError) {
          console.warn("Could not retry request after token refresh:", retryError);
        }
      }

      await handleTokenExpiration();
    }

    return Promise.reject(
      error instanceof Error ? error : new Error("unknown error")
    );
  };
}
